export default __webpack_public_path__ + "static/media/2019.5c83f2be.webp";